import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string) {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = Cookies.get('token')
  const headers: Record<string, string> = {}
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  if (token) headers.Authorization = `Bearer ${token}`
  const res = await fetch(buildUrl(path), {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) {
    if (res.status === 401 && token) {
      handleSessionExpired()
      throw new Error('Session expired')
    }
    const payload = await res.json().catch(() => null)
    const details = Array.isArray(payload?.error?.details) ? payload.error.details : null
    const detailMessage = details?.length
      ? details.map((d: { field?: string; message?: string }) => d.message || d.field).join('; ')
      : null
    let msg = detailMessage || payload?.error?.message || payload?.message || res.statusText || 'Request failed'
    if (typeof msg !== 'string') msg = 'Request failed'
    throw new Error(msg)
  }
  return res.json()
}

export interface WorkspaceSummary {
  id: string
  name: string
  description?: string
  joiningId: string
  createdBy: string
  role: 'owner' | 'admin' | 'member'
}

export async function createWorkspace(name: string, description?: string): Promise<WorkspaceSummary> {
  return request('POST', '/api/workspaces', { name, ...(description ? { description } : {}) })
}

export async function getMyWorkspaces(): Promise<WorkspaceSummary[]> {
  return request('GET', '/api/workspaces')
}

export async function joinWorkspace(joiningId: string): Promise<WorkspaceSummary> {
  const result = await request<{ workspace: WorkspaceSummary; membership: unknown }>(
    'POST',
    '/api/memberships/join',
    { joiningId },
  )
  return result.workspace
}
